export const SITE_ORIGIN = "https://bobbypaugh.com";

export function canonicalURL(value: string): string {
  const url = new URL(value, SITE_ORIGIN);
  url.protocol = "https:";
  url.host = "bobbypaugh.com";
  if (!url.pathname.endsWith("/") && !url.pathname.split("/").pop()?.includes(".")) {
    url.pathname += "/";
  }
  url.search = "";
  url.hash = "";
  return url.href;
}

export function setCanonical(value: string): void {
  const href = canonicalURL(value);
  const existing = Array.from(document.head.querySelectorAll<HTMLLinkElement>('link[rel="canonical"]'));
  const link = existing.shift() ?? document.createElement("link");
  existing.forEach((duplicate) => duplicate.remove());
  link.rel = "canonical";
  link.href = href;
  if (!link.isConnected) document.head.appendChild(link);

  const tags = Array.from(document.head.querySelectorAll<HTMLMetaElement>('meta[property="og:url"]'));
  const og = tags.shift() ?? document.createElement("meta");
  tags.forEach((duplicate) => duplicate.remove());
  og.setAttribute("property", "og:url");
  og.content = href;
  if (!og.isConnected) document.head.appendChild(og);
}